import { TopicResult } from "common/topic/dto/TopicResult";
import React from "react";
import styled from "styled-components";
import { InputWayTextCharElement } from "common/topic/input_way_text";
import TextCharEditElement from "./TextCharEditElement";
import {
  textCharNavActivateInitial,
  textCharNavActivePosBorders,
  toggleElementNavActivatePos,
} from "./TextCharEdit.logic";
import TextCharDelimiterNav from "./TextCharDelimiterNav";
import { getAddRecognizePosPayload } from "./TextCharEditPayload.logic";
import { useTextRecognizePosition } from "hooks/asocijator/topic/input_way_text/useTextRecognizePosition";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";
import { useTextCharSplit } from "hooks/asocijator/topic/input_way_text/useTextCharSplit";

type TextCharEditProps = {
  topic: TopicResult;
};

const TextCharEdit = ({ topic }: TextCharEditProps) => {
  const editElements: InputWayTextCharElement[] = useTextCharSplit(topic);
  const [textCharNavActivate, setTextCharNavActivate] = React.useState<
    boolean[][]
  >([]);
  const { textRecognizePositionMutate } = useTextRecognizePosition({
    invalidateKeysArray: [
      [QUERY_KEYS.ASOCIJATOR_CHARACTER_SEARCH],
      [QUERY_KEYS.ASOCIJATOR_CHARACTER_LIST_GET],
    ],
  });

  const navActivateToggleHandle = (tCharInd: number, elInd: number) => {
    const navActivate = toggleElementNavActivatePos(
      textCharNavActivate,
      tCharInd,
      elInd
    );
    setTextCharNavActivate(navActivate);
  };

  React.useEffect(() => {
    if (textCharNavActivate.length === 0 && editElements.length > 0) {
      setTextCharNavActivate(textCharNavActivateInitial(editElements));
    }
  }, [textCharNavActivate.length, editElements.length]);

  React.useEffect(() => {
    if (textCharNavActivate.length > 0) {
      const posBorders = textCharNavActivePosBorders(textCharNavActivate);
      if (posBorders.i2 >= 0) {
        const addRecognizePosPayload = getAddRecognizePosPayload({
          ...posBorders,
          elN: editElements,
        });
        console.log("da", posBorders, addRecognizePosPayload);
        textRecognizePositionMutate({
          topicId: topic.id,
          ...addRecognizePosPayload,
        });
        toast.success("Add recognize positions updated");
        setTextCharNavActivate(textCharNavActivateInitial(editElements));
      }
    }
  }, [textCharNavActivate]);

  return (
    <Div>
      <Div>Text Char Edit</Div>
      <DivEditElement>
        {textCharNavActivate.length > 0 &&
          editElements.map(
            (editElement: InputWayTextCharElement, textCharInd: number) => (
              <TextCharEditElement
                textCharElement={editElement}
                textCharInd={textCharInd}
                textCharNavActivate={textCharNavActivate}
                navActivateToggleHandle={navActivateToggleHandle}
              />
            )
          )}
        {editElements.length > 0 && (
          <TextCharDelimiterNav
            active={
              textCharNavActivate &&
              textCharNavActivate[editElements.length] &&
              textCharNavActivate[editElements.length][0]
            }
            onClick={() => navActivateToggleHandle(editElements.length, 0)}
          />
        )}
      </DivEditElement>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 0rem;
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const DivEditElement = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export default TextCharEdit;
